import gql from 'graphql-tag';

export const embeddedIntegrationItemFragment = gql`
  fragment embeddedIntegrationItemFragment on IntegrationItem {
    dokkioClass
    integrationID
    remoteID
    accountID
    name
    integrationItemType
    integrationItemKind
    mimeType
    bytes
    createdAt
    modifiedAt
    isTextExtractable
    isIntegrationRoot
    isPDFable
    isThumbnailable
    lastRevHash
    shortcutRemoteID
    shortcutIntegrationID
    shortcutMimeType
    specialFolderType
    fileContentMD5
    childrenCount
    duplicateFileCount
    parentPaths
  }
`;
export default embeddedIntegrationItemFragment;
